<!------------------------------------------TITLE----------------------------------------------->
<div class="title-box uk-border-rounded p-1 d-none d-sm-block">
  <div class="head-card p-1 inner-title-box">
    <h1 class="title-text text-center font-weight-bold">
      Our Products
    </h1>
    <div class="text-right">
      <h5 class="text-light">
        <span class="sub-menu" routerLink="/home-page">HOME </span>&nbsp;
        <span class="sub-menu" routerLink="/contact-us"> CONTACT</span>&nbsp;
        <span class="sub-menu" routerLink="/ourproducts"> PRODUCTS</span>&nbsp;
        <span class="sub-menu" routerLink="/verticals"> SERVICES</span>&nbsp;
      </h5>
    </div>
  </div>
</div>
<!--------------------------------------------------TITLE END-------------------------------------------->




<div class="container">
  <h3 class="text-center font-weight-bold" >PRODUCTS:</h3>
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/productimage.jpeg" width="40%" height="40%" alt="" />
    </div>
    <div class="list-section">
      <ul>
        <li>
          Our Screw Air Compressor is engineered for maximum efficiency and reliability, providing a steady supply of compressed air for your industrial applications.
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        <h3 class="font-weight-bold">CHILLER PRODUCT</h3>
        <li>Advanced Screw Technology: Provides stable air flow with reduced vibrations.
          Energy-Efficient: Lower power consumption with optimized motor design.</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/product3image.jpeg" alt="" />
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        
        <li>Reduce Your Operating Costs: Our compressors are designed to consume less energy, ensuring significant savings..
          </li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/product5image.jpeg" alt="Image 2" />
    </div>
  </div>
  &nbsp;&nbsp;
  <h3 class="text-center font-weight-bold" ></h3>
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/product6image.jpeg" alt="Image 1" />
    </div>
    <div class="list-section">
      <ul>
        <li>Eco-Friendly Operation: The design minimizes environmental impact, helping you meet sustainability goals.
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        <h3 class="font-weight-bold">SCREW AIR COMPRESSOR</h3>
        <li>The Screw Air Compressor provides continuous, reliable compressed air with reduced energy consumption. The advanced screw technology ensures high efficiency for your industrial operations.
          </li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/product7image.jpg" alt="" />
    </div>
  </div>
  &nbsp;&nbsp;
  <h3 class="text-center font-weight-bold" >PISTON AIR COMPRESSOR</h3>
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/product8image.webp" alt="" />
    </div>
    <div class="list-section">
      <ul>
        <li>The Piston Air Compressor delivers high-pressure compressed air, ideal for a variety of industrial applications. 
          It features a robust piston-driven mechanism for superior performance and reliability
          
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        <h3 class="font-weight-bold">AIR DRYER</h3>
        <li>Our Air Dryer removes moisture from compressed air, preventing rust, corrosion, and damage to equipment..</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/product9image.avif" alt="" />
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/product10image.jpeg" alt="" />
    </div>
    <div class="list-section">
      <ul>
        <h3 class="font-weight-bold">AIR RECEIVER TANK </h3>
        <li> The Air Receiver Tank acts as a buffer, storing compressed air for consistent supply during peak demand or when the compressor is not running.
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        <h3 class="font-weight-bold">WATER CHILLER </h3>
        <li>The Water Chiller provides reliable cooling for industrial processes, HVAC systems, and equipment, 
          maintaining optimal temperature conditions.</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/product11image.webp" alt="" />
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/product12image.jpeg" alt="" />
    </div>
    <div class="list-section">
      <ul>
        <h2 class="te font-weight-bold">OIL CHILLER</h2>
        <li>The Oil Chiller is designed to effectively cool oils used in industrial machinery,
           ensuring optimal performance and preventing overheating.
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        <h3 class="text-center font-weight-bold">AIR ACCESSORIES</h3>
        <li>Air Accessories such as filters, regulators, and lubricators enhance the performance and longevity of compressed 
          air systems by ensuring clean, dry, and properly regulated air..</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/product13image.jpg" alt="" />
    </div>
  </div>
  &nbsp;&nbsp;  &nbsp;&nbsp;
</div>






<!------------------------------------------------mobileview---------------------------------------------------------------------------->

<div class="container">
  <h3 class="text-center font-weight-bold" >PRODUCTS:</h3>
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/productimage.jpeg" width="40%" height="40%" alt="" />
    </div>
    <div class="list-section">
      <ul>
        <li>
          Our Screw Air Compressor is engineered for maximum efficiency and reliability, providing a steady supply of compressed air for your industrial applications.
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        <h3 class="font-weight-bold">CHILLER PRODUCT</h3>
        <li>Advanced Screw Technology: Provides stable air flow with reduced vibrations.
          Energy-Efficient: Lower power consumption with optimized motor design.</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/product3image.jpeg" alt="" />
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        
        <li>Reduce Your Operating Costs: Our compressors are designed to consume less energy, ensuring significant savings..
          </li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/product5image.jpeg" alt="Image 2" />
    </div>
  </div>
  &nbsp;&nbsp;
  <h3 class="text-center font-weight-bold" ></h3>
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/product6image.jpeg" alt="Image 1" />
    </div>
    <div class="list-section">
      <ul>
        <li>Eco-Friendly Operation: The design minimizes environmental impact, helping you meet sustainability goals.
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        <h3 class="font-weight-bold">SCREW AIR COMPRESSOR</h3>
        <li>The Screw Air Compressor provides continuous, reliable compressed air with reduced energy consumption. The advanced screw technology ensures high efficiency for your industrial operations.
          </li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/product7image.jpg" alt="" />
    </div>
  </div>
  &nbsp;&nbsp;
  <h3 class="text-center font-weight-bold" >PISTON AIR COMPRESSOR</h3>
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/product8image.webp" alt="" />
    </div>
    <div class="list-section">
      <ul>
        <li>The Piston Air Compressor delivers high-pressure compressed air, ideal for a variety of industrial applications. 
          It features a robust piston-driven mechanism for superior performance and reliability
          
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        <h3 class="font-weight-bold">AIR DRYER</h3>
        <li>Our Air Dryer removes moisture from compressed air, preventing rust, corrosion, and damage to equipment..</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/product9image.avif" alt="" />
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/product10image.jpeg" alt="" />
    </div>
    <div class="list-section">
      <ul>
        <h3 class="font-weight-bold">AIR RECEIVER TANK </h3>
        <li> The Air Receiver Tank acts as a buffer, storing compressed air for consistent supply during peak demand or when the compressor is not running.
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        <h3 class="font-weight-bold">WATER CHILLER </h3>
        <li>The Water Chiller provides reliable cooling for industrial processes, HVAC systems, and equipment, 
          maintaining optimal temperature conditions.</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/product11image.webp" alt="" />
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    <div class="image-section">
      <img src="./../../assets/img/projects/product12image.jpeg" alt="" />
    </div>
    <div class="list-section">
      <ul>
        <h2 class="te font-weight-bold">OIL CHILLER</h2>
        <li>The Oil Chiller is designed to effectively cool oils used in industrial machinery,
           ensuring optimal performance and preventing overheating.
          </li>
        
      </ul>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="item">
    
    <div class="list-section">
      <ul>
        <h3 class="text-center font-weight-bold">AIR ACCESSORIES</h3>
        <li>Air Accessories such as filters, regulators, and lubricators enhance the performance and longevity of compressed 
          air systems by ensuring clean, dry, and properly regulated air..</li>
      </ul>
    </div>
    <div class="image-section">
      <img src="./../../assets/img/projects/product13image.jpg" alt="" />
    </div>
  </div>
  &nbsp;&nbsp;
  &nbsp;&nbsp;
  
</div>